let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5k4Zc")).then(() => parcelRequire('1CasD'));